import { OnInit, Input, Output, EventEmitter, Component } from '@angular/core';
import { TipoPregunta } from '../shared/services/client';

@Component({
	template: `
	<button *ngIf="rowData.tipoPregunta !== TipoPregunta.PreguntaRespuestaCorta && rowData.tipoPregunta !== TipoPregunta.PreguntaAbierta"
		style="color: #fff; font-weight: 700;" type="button" class="btn btn-info" (click)="onClick()">Acción</button>
  `,
})
export class ButtonViewComponent implements OnInit {
	TipoPregunta = TipoPregunta;

	renderValue: string;

	@Input() value: string | number;
	@Input() rowData: any;

	@Output() save: EventEmitter<any> = new EventEmitter();

	ngOnInit() {
		this.renderValue = this.value.toString().toUpperCase();
	}

	onClick() {
		this.save.emit(this.rowData);
	}
}
